import React from "react";
import {
  IconButton as MuiIconButton,
  IconButtonProps as MuiIconButtonProps,
  Tooltip,
} from "@mui/material";

export interface IconButtonProps extends MuiIconButtonProps {
  tooltip?: string;
}

const IconButton: React.FC<IconButtonProps> = ({ tooltip, ...props }) => {
  const button = <MuiIconButton {...props} />;

  if (!tooltip) return button;

  return (
    <Tooltip title={tooltip} arrow>
      {props.disabled ? <span>{button}</span> : button}
    </Tooltip>
  );
};

export default IconButton;
